import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FastForwardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fast_forward"}/>
}
